import './css/app.scss';


import './js/assets/slider.js';


import popups from './js/assets/popups';
import mobMenu from './js/assets/mobMenu';
import textChange from './js/assets/textChange';
import buyingOptions from './js/assets/buying';
import topTop from './js/assets/goToTop';
import categoryTabs from './js/assets/categoryTabs';
import accordian from './js/assets/accordian';
import stickyHeader from './js/assets/stickyHeader';
import temeout from './js/assets/timeout';


popups.init();
mobMenu.init();
textChange.init();
// buyingOptions.init();
topTop.init();
categoryTabs.init();
accordian.init();
stickyHeader.init();
temeout.init();    

window.resetEvent = new Event('reset');

import './js/assets/neto.js';


